let lotteryTicketNumbers = [
  {
    America_Lotto: {
      content: "lottos.americaLotto",
      digits: 52,
      image: "/07/Lotto_America-300x300.webp",
      luckyDigits: 10,
      max_mega_digits: 1,
      maximum_digits: 5,
      minimum_lines: 4,
      name: "America Lotto",
      price_per_ticket: 1,
    },
  },
  {
    El_Gordo: {
      content: "lottos.elgordoLotto",
      digits: 54,
      image: "/07/el-gordo-big-300x256.webp",
      luckyDigits: 0,
      maximum_digits: 5,
      minimum_lines: 3,
      name: "El Gordo",
      price_per_ticket: 1,
    },
  },
  {
    EuroJackpots: {
      content: "lottos.eurojackpotLotto",
      digits: 50,
      image: "/07/EuroJackpot-300x300.webp",
      luckyDigits: 12,
      max_mega_digits: 2,
      maximum_digits: 5,
      minimum_lines: 2,
      name: "Euro Jackpots",
      price_per_ticket: 1,
    },
  },
  {
    EuroMillions: {
      content: "lottos.euromillionsLotto",
      digits: 50,
      image: "/07/Euromillions-300x300.webp",
      luckyDigits: 12,
      max_mega_digits: 2,
      maximum_digits: 5,
      minimum_lines: 2,
      name: "Euro Millions",
      price_per_ticket: 1,
    },
  },
  {
    France_Lotto: {
      content: "lottos.frenchLotto",
      digits: 49,
      image: "/07/French_lotto-300x300.webp",
      luckyDigits: 10,
      max_mega_digits: 1,
      maximum_digits: 5,
      minimum_lines: 2,
      name: "France Lotto",
      price_per_ticket: 1,
    },
  },
  {
    German_Lotto: {
      content: "lottos.germanLotto",
      digits: 49,
      image: "/07/German_lotto-300x300.webp",
      luckyDigits: 0,
      max_mega_digits: 0,
      maximum_digits: 6,
      minimum_lines: 4,
      name: "German Lotto",
      price_per_ticket: 1,
    },
  },
  {
    La_Primitiva: {
      content: "lottos.laprimitivaLotto",
      digits: 49,
      image: "/07/La_Primitiva-300x300.webp",
      luckyDigits: 0,
      max_mega_digits: 0,
      maximum_digits: 6,
      minimum_lines: 4,
      name: "La Primitiva",
      price_per_ticket: 1,
    },
  },
  {
    MegaMillions: {
      content: "lottos.megamillionsLotto",
      digits: 70,
      image: "/07/megamillions-300x300.webp",
      luckyDigits: 24,
      max_mega_digits: 1,
      maximum_digits: 5,
      minimum_lines: 1,
      name: "Mega Millions",
      price_per_ticket: 1,
    },
  },
  {
    MegaSena: {
      content: "lottos.megasenaLotto",
      digits: 60,
      image: "/07/MegaSena-300x300.webp",
      luckyDigits: 0,
      max_mega_digits: 0,
      maximum_digits: 6,
      minimum_lines: 4,
      name: "Mega Sena",
      price_per_ticket: 1,
    },
  },
  {
    Powerball_Australia: {
      content: "lottos.powerballauLotto",
      digits: 35,
      image: "/07/PowerballAU-300x300.webp",
      luckyDigits: 20,
      max_mega_digits: 1,
      maximum_digits: 7,
      minimum_lines: 4,
      name: "Powerball Australia",
      price_per_ticket: 1,
    },
  },
  {
    PowerUSA: {
      content: "lottos.powerballusLotto",
      digits: 69,
      image: "/07/powerball-300x300.webp",
      luckyDigits: 26,
      max_mega_digits: 1,
      maximum_digits: 5,
      minimum_lines: 2,
      name: "Power USA",
      price_per_ticket: 1,
    },
  },
  {
    Saturday_Lotto: {
      content: "lottos.saturdayLotto",
      digits: 45,
      image: "/07/SaturdayLotto-300x300.webp",
      luckyDigits: 0,
      max_mega_digits: 0,
      maximum_digits: 6,
      minimum_lines: 8,
      name: "Saturday Lotto",
      price_per_ticket: 1,
    },
  },
  {
    SetForLife: {
      content: "lottos.setforlifeLotto",
      digits: 47,
      image: "/07/SetForLifeUK-300x300.webp",
      luckyDigits: 10,
      max_mega_digits: 1,
      maximum_digits: 5,
      minimum_lines: 3,
      name: "Set For Life",
      price_per_ticket: 1,
    },
  },
  {
    Superenalotto: {
      content: "lottos.superenaLotto",
      digits: 90,
      image: "/07/SuperEnalotto-300x300.webp",
      luckyDigits: 0,
      max_mega_digits: 0,
      maximum_digits: 6,
      minimum_lines: 3,
      name: "Superena lotto",
      price_per_ticket: 1,
    },
  },
  {
    ThunderBall: {
      content: "lottos.thunderballLotto",
      digits: 39,
      image: "/07/ThunderBall-300x300.webp",
      luckyDigits: 14,
      max_mega_digits: 1,
      maximum_digits: 5,
      minimum_lines: 4,
      name: "Thunder Ball",
      price_per_ticket: 1,
    },
  },
  {
    UK_Lottery: {
      content: "lottos.ukLotto",
      digits: 59,
      image: "/07/UK_Lottery-300x300.webp",
      luckyDigits: 0,
      max_mega_digits: 0,
      maximum_digits: 6,
      minimum_lines: 3,
      name: "UK Lottery",
      price_per_ticket: 1,
    },
  },
  {
    NewYorkLotto: {
      content: "lottos.newyorkLotto",
      digits: 59,
      image: "/10/Lotto-NY-300x300.png",
      luckyDigits: 59,
      max_mega_digits: 1,
      maximum_digits: 6,
      minimum_lines: 10,
      name: "UK Lottery",
      price_per_ticket: 1,
    },
  },
  {
    EuroMillions_AT: {
      content: "lottos.euromillionsLotto",
      digits: 50,
      image: "/07/Euromillions-300x300.webp",
      luckyDigits: 12,
      max_mega_digits: 2,
      maximum_digits: 5,
      minimum_lines: 2,
      name: "Euro Millions Austria",
      price_per_ticket: 1,
    },
  },
];
export default lotteryTicketNumbers;
